<template>
    <div>
        <b-table
            :items="all_products"
            :fields="fields"
            responsive="sm"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :busy="all_products_loading_status === true"
            :tbody-tr-class="rowClass"
            show-empty
        >
            <template #cell(name)="data">
                {{ data.item.name }}
            </template>

            <template #cell(stock_quantity)="data">
                <stock-badge
                    :quantity="data.item.stock_quantity || 0"
                    :low-threshold="data.item.low_stock_threshold || 5"
                />
                <span class="ml-1">{{ data.item.stock_quantity || 0 }}</span>
            </template>

            <template #cell(actions)="data">
                <div class="tableIcons">
                    <i
                        class="fas fa-binoculars viewAction"
                        @click="handleView(data.item)"
                    ></i>&nbsp;
                    <i
                        class="fas fa-pen editAction"
                        @click="handleEdit(data.item)"
                    ></i>&nbsp;
                    <i
                        class="fas fa-boxes adjustStockAction"
                        @click="handleAdjustStock(data.item)"
                        title="Adjust Stock"
                    ></i>&nbsp;
                    <i
                        class="fas fa-trash deleteAction"
                        @click="handleDelete(data.item)"
                    ></i>
                </div>
            </template>

            <template #empty>
                <div class="text-center text-muted py-4">
                    No products match your filters.
                    <a href="#" @click.prevent="clearFilters">Clear Filters</a>
                </div>
            </template>

            <template #table-busy>
                <div class="text-center text-muted my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
import { productMethods, productComputed } from "@/state/helpers";
import stockBadge from "@/components/shared/stockBadge.vue";

export default {
    components: {
        stockBadge,
    },
    data: () => ({
        sortBy: "name",
        sortDesc: false,
        fields: [
            {
                key: "actions",
                label: "Actions",
                sortable: false,
                thStyle: { width: "130px" },
            },
            {
                key: "name",
                label: "Product Name",
                sortable: true,
            },
            {
                key: "sku",
                label: "SKU",
                sortable: true,
            },
            {
                key: "price",
                label: "Price",
                sortable: true,
            },
            {
                key: "stock_quantity",
                label: "Stock",
                sortable: true,
            },
            {
                key: "current_status",
                label: "Status",
                sortable: true,
            },
            {
                key: "group_names",
                label: "Group",
                sortable: true,
            },
        ],
    }),
    computed: {
        ...productComputed,
    },
    methods: {
        ...productMethods,
        rowClass(item) {
            if (!item) return "";
            if (item.stock_quantity === 0) return "table-row-out-of-stock";
            if (
                item.stock_quantity <=
                (item.low_stock_threshold || 5)
            )
                return "table-row-low-stock";
            return "";
        },
        handleView(item) {
            this.setSelectedProduct(item.id);
        },
        handleEdit(item) {
            this.$emit("editProduct", item.id);
        },
        handleAdjustStock(item) {
            this.$emit("adjustStock", item.id);
        },
        handleDelete(item) {
            this.$swal
                .fire({
                    title:
                        "Are you sure you want to delete " + item.name + "?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, delete it!",
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteProduct({ id: item.id }).then(() => {
                            this.getProducts();
                        });
                    }
                });
        },
        clearFilters() {
            this.sortBy = "name";
            this.sortDesc = false;
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
@import "~@/design/tokens/brand";
@import "~@/design/tokens/feedback";

::v-deep .table-row-low-stock {
    background-color: rgba($feedback-warning, 0.08) !important;
}
::v-deep .table-row-out-of-stock {
    background-color: rgba($feedback-error, 0.05) !important;
}
</style>
